// Import model
import { CreateFromSelectionsRequest } from '../models/CreateFromSelectionsRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateFromSelectionsRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateFromSelectionsRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateFromSelectionsRequest instance
   */
  static deserialize(json: string): CreateFromSelectionsRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateFromSelectionsRequest instance
   */
  static fromObject(obj: any): CreateFromSelectionsRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateFromSelectionsRequest');
    }


    const instance: CreateFromSelectionsRequest = {
      description: obj['description'] as string | undefined,
      flowid: obj['flowid'] as string | undefined,
      flowidName: obj['flowid|Name'] as string | undefined,
      name: obj['name'] as string,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      objectStatusIdName: obj['objectStatusId|Name'] as string | undefined,
      roomSelectionIds: obj['roomSelectionIds'] ? (obj['roomSelectionIds'] as any[]).map((item: any) =>
        item as string
      ) : [],
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateFromSelectionsRequest instances
   */
  static deserializeArray(json: string): CreateFromSelectionsRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateFromSelectionsRequest instance to a JSON string
   */
  static serialize(instance: CreateFromSelectionsRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateFromSelectionsRequest instance to a plain object
   */
  static toObject(instance: CreateFromSelectionsRequest): any {
    return {
      'description': instance.description,
      'flowid': instance.flowid,
      'flowid|Name': instance.flowidName,
      'name': instance.name,
      'objectStatusId': instance.objectStatusId,
      'objectStatusId|Name': instance.objectStatusIdName,
      'roomSelectionIds': instance.roomSelectionIds?.map((item: any) =>
        item
      ),
    };
  }

  /**
   * Serializes an array of CreateFromSelectionsRequest instances to a JSON string
   */
  static serializeArray(instances: CreateFromSelectionsRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
